/* >>>>>>>>>>>>>> EXPORT_USER >>>>>>>>>>>>>>>*/
export const EXPORT_USER = "EXPORT_USER";
export const EXPORT_USER_SUCCESS = "EXPORT_USER_SUCCESS";
export const EXPORT_USER_FAIL = "EXPORT_USER_FAIL";
